import axios from "axios";

export const API_BASE = "/api";

export const api = axios.create({
  baseURL: API_BASE,
});

// Attach Authorization header if we have a token in localStorage
api.interceptors.request.use((config) => {
  const t = localStorage.getItem("ks_token");

  if (t) {
    config.headers.Authorization = `Bearer ${t}`;
  }

  return config;
});

// --- helpers ---

export const shortHash = (h, left = 10, right = 8) => {
  if (!h) {
    return "";
  }

  if (h.length <= left + right + 3) {
    return h;
  }

  const end = right > 0 ? h.slice(-right) : "";

  return `${h.slice(0, left)}…${end}`;
};

export const shortAddr = (a, left = 8, right = 6) => {
  return shortHash(a, left, right);
};

export const timeAgo = (unixSec) => {
  if (!unixSec) {
    return "-";
  }

  const diff = Math.max(
    1,
    Math.floor(Date.now() / 1000) - Number(unixSec)
  );

  if (diff < 60) {
    return `${diff} sec${diff === 1 ? "" : "s"} ago`;
  }

  const m = Math.floor(diff / 60);

  if (m < 60) {
    return `${m} min${m === 1 ? "" : "s"} ago`;
  }

  const h = Math.floor(m / 60);

  if (h < 24) {
    return `${h} hr${h === 1 ? "" : "s"} ago`;
  }

  const d = Math.floor(h / 24);

  return `${d} day${d === 1 ? "" : "s"} ago`;
};

export const formatEth = (v, digits = 6) => {
  if (v == null) {
    return "0";
  }

  let n = Number(v);

  if (!Number.isFinite(n) || n === 0) {
    return "0";
  }

  // Never display negative ETH balances
  // Real blockchains never have negative balances.
  if (n < 0) {
    n = 0;
  }

  if (n === 0) {
    return "0";
  }

  const abs = Math.abs(n);

  if (abs < 0.000001) {
    return n.toExponential(2);
  }

  const fixed = n.toFixed(digits);

  return fixed
    .replace(/(\.\d*?[1-9])0+$/, "$1")
    .replace(/\.0+$/, "")
    .replace(/\.$/, "");
};

export const formatNumber = (v) => {
  if (v == null) {
    return "0";
  }

  return Number(v).toLocaleString("en-US");
};